<div class="container tv-block-container" *ngIf="!noDataHide">
    <div class="block-title">
        <div class="d-flex align-items-center">
            <div class="logo-icon"></div>
            <div class="d-flex align-items-center">
                <h3 class="d-inline">
                    <a [routerLink]="['/tvlive']">
                        <span>电视直播</span>
                    </a>
                </h3>
                <a [routerLink]="['/tvlive']" class="mainColor d-flex align-items-center ml-4">
                    <span>更多</span>
                    <span class="iconfont iconjiantou_liebiaoxiangyou fs-16"></span>
                </a>
            </div>
        </div>
    </div>
    <div class="tv-live-slider-container">
        <ng-container>
            <div class="rec-slider position-relative d-flex align-items-start v-n-place" [ngClass]="{'pureBg': tvList.length > 0}">
                <div class="tv-nav-shadow-cover last" *ngIf="currentIndex > 0"
                  [ngClass]="{'hidden': hideLeft}">
                </div>
                <div class="tv-nav-btn last" *ngIf="currentIndex > 0"
                  [ngClass]="{'hidden': hideLeft}">
                  <i class="iconfont iconjiantou_liebiaoxiangzuo" (click)="navLast()"></i>
                </div>
                <div class="rec-track d-flex" #track>
                    <div class="tv-box" *ngFor="let item of tvList"
                        style="margin-right: 5px;">
                        <div class="tv-cover">
                            <a [routerLink]="['/play',item.key]" [queryParams]="{id: item.lastKey}" title="{{ item.title }}">
                                <img src="{{item.image | safeResource}}?w=216&h=216&format=jpg&mode=crop" />
                            </a>
                        </div>
                        <div class="tv-title">
                            <a [routerLink]="['/play',item.key]" [queryParams]="{id: item.lastKey}" title="{{ item.title }}">{{ item.title }}</a>
                        </div>
                    </div>
                </div>
                <div class="tv-nav-shadow-cover next" *ngIf="currentIndex < (tvList.length - newColumn)"
                  [ngClass]="{'hidden': hideRight}">
                </div>
                <div class="tv-nav-btn next" *ngIf="currentIndex < (tvList.length - newColumn)" 
                  [ngClass]="{'hidden': hideRight}">
                  <i class="iconfont iconjiantou_liebiaoxiangyou" (click)="navNext()"></i>
                </div>
            </div>
        </ng-container>
    </div>
</div>